import type { CSSProperties, FC } from 'react';
import type { ClientCardId, ClientOverviewStats } from '../types';
import {
  CalendarIcon,
  ConnectionsIcon,
  FilesIcon,
  NotebookIcon,
  ProjectIcon,
  RequestIcon,
  ToolsIcon,
} from './ClientIcons';

interface ClientGridProps {
  stats: ClientOverviewStats;
  onSelectCard: (id: ClientCardId) => void;
  activeCard?: ClientCardId | null;
}

interface CardMeta {
  id: ClientCardId;
  num: string;
  title: string;
  subtitle: string;
  badge: number | string;
  accent: string;
  icon: FC<{ className?: string }>;
}

export const ClientGrid: FC<ClientGridProps> = ({ stats, onSelectCard, activeCard }) => {
  const cards: CardMeta[] = [
    {
      id: 'MY_REQUESTS',
      num: '01',
      title: 'Мои заявки',
      subtitle: 'Статусы, история и готовые результаты',
      badge: stats.in_progress_requests || stats.total_requests,
      accent: '#e2ad3a',
      icon: RequestIcon,
    },
    {
      id: 'MY_PROJECTS',
      num: '02',
      title: 'Мои проекты',
      subtitle: 'Этапы выполнения, прогресс и артефакты',
      badge: stats.active_projects,
      accent: '#49ddb7',
      icon: ProjectIcon,
    },
    {
      id: 'ACADEMIC_CALENDAR',
      num: '03',
      title: 'Академический календарь',
      subtitle: 'Дедлайны, консультации и события',
      badge: stats.upcoming_deadlines,
      accent: '#41d2ff',
      icon: CalendarIcon,
    },
    {
      id: 'ACADEMIC_CONNECTIONS',
      num: '04',
      title: 'Академические связи',
      subtitle: 'Менеджер, учёные и соавторы',
      badge: stats.unread_messages ? `+${stats.unread_messages}` : 'Диалог',
      accent: '#9e80ff',
      icon: ConnectionsIcon,
    },
    {
      id: 'RESEARCH_TOOLS',
      num: '05',
      title: 'Научные инструменты',
      subtitle: 'Антиплагиат, AI-детектор, журналы',
      badge: '5',
      accent: '#5da8ff',
      icon: ToolsIcon,
    },
    {
      id: 'ACADEMIC_NOTEBOOK',
      num: '06',
      title: 'Академический блокнот',
      subtitle: 'Записи, идеи и рабочие заметки',
      badge: 'Заметки',
      accent: '#ff7a64',
      icon: NotebookIcon,
    },
    {
      id: 'B5_FILES',
      num: '07',
      title: 'Хранилище файлов',
      subtitle: 'Материалы, документы и результаты',
      badge: stats.total_files,
      accent: '#49ddb7',
      icon: FilesIcon,
    },
  ];

  return (
    <section className="owner-hub-grid client-actions" aria-label="Рабочие разделы клиента">
      {cards.map((card) => {
        const Icon = card.icon;
        const isActive = activeCard === card.id;

        return (
          <button
            key={card.id}
            type="button"
            onClick={() => onSelectCard(card.id)}
            className={`owner-hub-card${isActive ? ' is-opening' : ''}`}
            style={{ '--action': card.accent } as CSSProperties}
          >
            <span className="owner-hub-index">{card.num}</span>
            <span className="owner-hub-icon" aria-hidden="true">
              <Icon className="w-5 h-5" />
            </span>
            <span className="owner-hub-copy">
              <strong>{card.title}</strong>
              <span>
                {card.subtitle} · {card.badge}
              </span>
            </span>
            <span className="owner-hub-arrow" aria-hidden="true">
              ›
            </span>
          </button>
        );
      })}
    </section>
  );
};
